const oralSurgery = {
  hero: {
    badgeIconAlt: "Oral Surgery Icon",
    badgeText: "Ακριβείς Στοματικές Επεμβάσεις",
    titleLine1: "Προηγμένες Λύσεις",
    titleLine2: "Στοματικής Χειρουργικής",
    description:
      "Οι εξειδικευμένοι στοματικοί χειρουργοί μας προσφέρουν ακριβείς θεραπείες για εξαγωγές, προβλήματα γνάθου και στοματικές παθήσεις, χρησιμοποιώντας υπερσύγχρονες τεχνικές για ταχύτερη επούλωση και βέλτιστα αποτελέσματα.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Μάθετε Περισσότερα",
    },
    heroImageAlt: "Advanced Oral Surgery",
    stats: {
      successRateLabel: "Ποσοστό Επιτυχίας",
      successRateValue: "97%+",
      recoveryLabel: "Επούλωση",
      recoveryValue: "Γρήγορη",
    },
    experience: {
      label: "Χειρουργική εμπειρία",
      value: "12+ Χρόνια Εμπειρίας",
    },
  },
  benefits: {
    heading: "ΓΙΑΤΙ ΝΑ ΕΠΙΛΕΞΕΤΕ ΤΗ ΣΤΟΜΑΤΙΚΗ ΧΕΙΡΟΥΡΓΙΚΗ ΜΑΣ",
    intro: "Ζήστε υπερσύγχρονες χειρουργικές επεμβάσεις με βέλτιστα αποτελέσματα και μέγιστη άνεση.",
    items: [
      {
        title: "Ακριβείς Θεραπείες",
        description:
          "Οι χειρουργοί μας χρησιμοποιούν προηγμένη απεικόνιση και μικροχειρουργικές τεχνικές για το υψηλότερο επίπεδο ακρίβειας σε κάθε επέμβαση.",
      },
      {
        title: "Ελάχιστη Ενόχληση",
        description:
          "Σύγχρονες μέθοδοι αναισθησίας και ελάχιστα επεμβατικές τεχνικές εξασφαλίζουν την άνεσή σας πριν, κατά τη διάρκεια και μετά τη χειρουργική επέμβαση.",
      },
      {
        title: "Ταχεία Ανάρρωση",
        description:
          "Οι προηγμένες προσεγγίσεις μας μειώνουν τους χρόνους επούλωσης, το πρήξιμο και επιταχύνουν την επιστροφή στις καθημερινές δραστηριότητες.",
      },
    ],
  },
  process: {
    heading: "Η ΧΕΙΡΟΥΡΓΙΚΗ ΔΙΑΔΙΚΑΣΙΑ",
    intro: "Η δομημένη προσέγγισή μας διασφαλίζει εξαιρετική φροντίδα και αποτελέσματα.",
    steps: [
      {
        title: "Συνολική Αξιολόγηση",
        description:
          "Ξεκινάμε με μια πλήρη εκτίμηση της στοματικής σας υγείας, του ιατρικού σας ιστορικού και ακτινογραφιών, ώστε να διαμορφώσουμε το εξατομικευμένο σας πλάνο θεραπείας.",
      },
      {
        title: "Προεγχειρητική Προετοιμασία",
        description:
          "Συζητάμε τις επιλογές αναισθησίας, σας παρέχουμε αναλυτικές προεγχειρητικές οδηγίες και απαντούμε σε όλες σας τις απορίες για να είστε πλήρως προετοιμασμένοι.",
      },
      {
        title: "Ακριβής Χειρουργική Πράξη",
        description:
          "Με τη χρήση προηγμένων τεχνικών και τεχνολογίας, οι χειρουργοί μας εκτελούν την επέμβασή σας με εξαιρετική ακρίβεια και φροντίδα.",
      },
      {
        title: "Μετεγχειρητική Φροντίδα",
        description:
          "Παρέχουμε αναλυτικές οδηγίες φροντίδας μετά την επέμβαση και προγραμματισμένες επανεξετάσεις για τη βέλτιστη επούλωση και τα καλύτερα αποτελέσματα.",
      },
    ],
  },
  faq: {
    heading: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ",
    intro: "Βρείτε απαντήσεις σε κοινές απορίες σχετικά με τις στοματικές χειρουργικές μας επεμβάσεις.",
    items: [
      {
        question: "Ποιους τύπους στοματικής χειρουργικής πραγματοποιείτε;",
        answer:
          "Προσφέρουμε ένα πλήρες φάσμα στοματικών χειρουργικών επεμβάσεων, όπως αφαίρεση φρονιμίτων, τοποθέτηση εμφυτευμάτων, οστικά μοσχεύματα, χειρουργική γνάθου, βιοψίες και αντιμετώπιση τραυμάτων ή λοιμώξεων στο πρόσωπο.",
      },
      {
        question: "Πώς πρέπει να προετοιμαστώ για τη χειρουργική επέμβαση;",
        answer:
          "Η προετοιμασία εξαρτάται από τη συγκεκριμένη διαδικασία. Σε γενικές γραμμές, αν λάβετε ολική αναισθησία , θα πρέπει να ακολουθήσετε οδηγίες νηστείας, να κανονίσετε συνοδεία για την επιστροφή σας στο σπίτι, να φορέσετε άνετα ρούχα και να ακολουθήσετε προσεκτικά όλες τις προεγχειρητικές οδηγίες της ομάδας μας.",
      },
      {
        question: "Πόσο διαρκεί η ανάρρωση;",
        answer:
          "Η διάρκεια της ανάρρωσης διαφέρει ανάλογα με την επέμβαση και τον ρυθμό επούλωσης κάθε ατόμου. Οι απλές εξαγωγές μπορεί να χρειάζονται μόνο μερικές ημέρες, ενώ οι πιο σύνθετες επεμβάσεις ενδέχεται να απαιτούν 1-2 εβδομάδες για αρχική ανάρρωση. Θα σας δώσουμε συγκεκριμένες πληροφορίες με βάση τη δική σας περίπτωση.",
      },
      {
        question: "Θα πονάω κατά τη διάρκεια της επέμβασης;",
        answer:
          "Η άνεσή σας είναι προτεραιότητά μας. Χρησιμοποιούμε σύγχρονες μεθόδους αναισθησίας ώστε να μην αισθάνεστε πόνο κατά τη διάρκεια της επέμβασης. Ο μετεγχειρητικός πόνος αντιμετωπίζεται με τα κατάλληλα αναλγητικά και αναλυτικές οδηγίες φροντίδας.",
      },
      {
        question: "Ποιοι είναι οι πιθανοί κίνδυνοι της στοματικής χειρουργικής;",
        answer:
          "Αν και η στοματική χειρουργική θεωρείται γενικά ασφαλής, κάθε χειρουργική επέμβαση έχει κάποιους κινδύνους, όπως λοίμωξη, αιμορραγία, βλάβη νεύρων ή αντιδράσεις στην αναισθησία. Ενημερωνόμαστε πλήρως για όλους τους πιθανούς κινδύνους και λαμβάνουμε κάθε απαραίτητο μέτρο για να τους ελαχιστοποιήσουμε.",
      },
    ],
  },
};

export default oralSurgery;

